"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcPagination = _interopRequireDefault(require("rc-pagination"));
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _Icon = _interopRequireDefault(require("../Icon"));
var _default2 = _interopRequireDefault(require("../locales/default"));
var _LocaleContext = require("../locales/LocaleContext");
var _StyledPagination = require("./StyledPagination");
var _excluded = ["prefixCls", "className", "size", "showTotal", "bordered"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Pagination = /*#__PURE__*/function (_Component) {
  function Pagination() {
    var _this;
    (0, _classCallCheck2.default)(this, Pagination);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Pagination, [].concat(args));
    (0, _defineProperty2.default)(_this, "renderPager", function (localeCode, locale) {
      var _this$props = _this.props,
        prefixCls = _this$props.prefixCls,
        className = _this$props.className,
        size = _this$props.size,
        _showTotal = _this$props.showTotal,
        bordered = _this$props.bordered,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledPagination.StyledPaginationContainer, {
          theme: theme,
          size: size,
          bordered: bordered,
          prefixCls: prefixCls
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_rcPagination.default, (0, _extends2.default)({
            prefixCls: styledPrefix,
            className: className,
            locale: locale,
            showTotal: function showTotal(total, range) {
              if (_showTotal) {
                if (typeof _showTotal === 'boolean') {
                  return locale.totalText.replace('{total}', total);
                } else if (typeof _showTotal === 'function') {
                  var result = _showTotal(total, range);
                  return result;
                }
              }
              return false;
            }
          }, rest));
        });
      });
    });
    return _this;
  }
  (0, _inherits2.default)(Pagination, _Component);
  return (0, _createClass2.default)(Pagination, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "Pagination",
        defaultLocale: _default2.default.Pagination
      }, this.renderPager);
    }
  }]);
}(_react.Component);
Pagination.propTypes = {
  prefixCls: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  current: _propTypes.default.number,
  defaultCurrent: _propTypes.default.number,
  total: _propTypes.default.number,
  pageSize: _propTypes.default.number,
  defaultPageSize: _propTypes.default.number,
  onChange: _propTypes.default.func,
  hideOnSinglePage: _propTypes.default.bool,
  showPrevNextJumpers: _propTypes.default.bool,
  showQuickJumper: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  showTitle: _propTypes.default.bool,
  pageSizeOptions: _propTypes.default.arrayOf(_propTypes.default.string),
  showTotal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  size: _propTypes.default.oneOf(['default', 'small', 'large']),
  style: _propTypes.default.object,
  prevIcon: _propTypes.default.object,
  nextIcon: _propTypes.default.object,
  jumpPrevIcon: _propTypes.default.object,
  jumpNextIcon: _propTypes.default.object,
  bordered: _propTypes.default.bool
};
Pagination.defaultProps = {
  jumpNextIcon: /*#__PURE__*/_react.default.createElement(JumpNextIcon, null),
  jumpPrevIcon: /*#__PURE__*/_react.default.createElement(JumpPrevIcon, null),
  nextIcon: /*#__PURE__*/_react.default.createElement(NextIcon, null),
  prevIcon: /*#__PURE__*/_react.default.createElement(PrevIcon, null),
  bordered: false,
  size: 'default'
};
function JumpNextIcon() {
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "12",
    name: "angle-double-right"
  });
}
function JumpPrevIcon() {
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "12",
    name: "angle-double-left"
  });
}
function NextIcon() {
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "ykb-pagination-item-link"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "16",
    name: "angle-right"
  }));
}
function PrevIcon() {
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "ykb-pagination-item-link"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "16",
    name: "angle-left"
  }));
}
var _default = exports.default = Pagination;